import { Page } from "pages/styled"
import ContentCode from "./components/code"
import ContentFields from "./components/content-fields"
import Header from "./components/header"
import { ContentEditorStoreProvider } from "./store"
import { Column } from "./styled"

type Props = {
  params?: { id: string }
}

const ContentPage = ({ params }: Props) => {

  return (
    <ContentEditorStoreProvider>
      <Page sx={{ display: "flex", justifyContent: "center" }}>
        <Column sx={{ mt: 5, ml: "auto", maxWidth: 600 }}>
          <Header id={params?.id} />
          <ContentFields/>
        </Column>
        <Column sx={{ maxWidth: 600, bgcolor: "background.paper", ml: "auto", my: 5, borderRadius: "20px 0 0 20px" }}>
          <ContentCode />
        </Column>
      </Page>
    </ContentEditorStoreProvider>
  )
}

export default ContentPage